import { ActionStickerCardProps, ImageCardProps } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

import type { useGetToolsPageSections } from './hooks/useGetToolsPageSections';

type ToolsAgentContextParams = ReturnType<typeof useGetToolsPageSections>;

const toToolContext = (cards: ActionStickerCardProps[]) =>
  cards.map((card) => ({
    title: card.tool?.title ?? card.title,
    description: card.tool?.internal_description ?? card.tool?.description ?? card.description,
    keywords: card.tool?.keywords,
  }));

const toImageCardContext = (cards: ImageCardProps[]) =>
  cards.map((card) => ({
    title: card.title,
    description: card.description,
  }));

export const useAgentContext = ({
  collegeSolutions,
  guides,
  exploratoryTools,
  careerSolutions,
  backrsAssessments,
}: ToolsAgentContextParams) => {
  useRegisterAgentContext({
    kind: 'section',
    title: collegeSolutions.title,
    description: collegeSolutions.description,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: `Tools in the "${collegeSolutions.title}" section`,
    data: toToolContext(collegeSolutions.actionStickerCards),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: guides.title,
    description: guides.description,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: `Guides in the "${guides.title}" section`,
    data: guides.nuggets.map((nugget) => ({
      title: nugget.title,
      description: nugget.description,
    })),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: exploratoryTools.title,
    description: exploratoryTools.description,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: `Tools in the "${exploratoryTools.title}" section`,
    data: toImageCardContext(exploratoryTools.imageCards),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: careerSolutions.title,
    description: careerSolutions.description,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: `Tools in the "${careerSolutions.title}" section`,
    data: toToolContext(careerSolutions.actionStickerCards),
  });

  useRegisterAgentContext({
    kind: 'section',
    title: backrsAssessments.title,
    description: backrsAssessments.description,
  });

  useRegisterAgentContext({
    kind: 'list',
    description: `Tools in the "${backrsAssessments.title}" section`,
    data: toToolContext(backrsAssessments.actionStickerCards),
  });
};
